import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pm-insurancemaster',
  templateUrl: './insurancemaster.component.html',
  styleUrls: ['./insurancemaster.component.css']
})
export class InsurancemasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
